<template>
  <div class="sm_div">
    <div>
      <p class="title">指标说明</p>
      <p>成交总额GMV：在统计时间内下单且支付成功的主订单金额（不含运费和退款）。</p>
      <p>总订单量：在统计时间内下单且支付成功的订单数量（快读订单量+自主订单量=总订单量）</p>
      <p>快速订单量：在统计时间内下单且支付成功的快速订单数量</p>
      <p>自主订单量：在统计时间内下单且支付成功的自主订单数量</p>
      <p>订单商品数：在统计时间内下单且支付成功的商品规格件数（注：规格*规格具体数量）</p>
      <p>下单人数：在统计时间内下单且支付成功的人数（人数去重）</p>
      <p>客单价：成交总金额GMV/下单人数</p>
      <p>退款订单金额：在统计时间内用户申请的已支付成功的退款子订单金额（按售后完成时间（退款成功时间））</p>
      <p>退款订单数：在统计时间内用户申请的已支付成功的退款子订子订单数量</p>
      <p>退款订单用户数：在统计时间内用户申请的已支付成功的退款子用户人数（人数去重）</p>
      <p>售后统计指标说明</p>
      <p>用户申请退货订单金额：在统计时间内订单的用户申请退货的订单金额</p>
      <p>已结算退货订单金额：在统计时间内已结算退货的订单金额（金额已通过第三方支付已支付给用户）</p>
      <p>售后单数：在统计时间内退货的售后单数（只计算退货数量）</p>
      <p>退货用户数：在统计时间内退货的用户数（人数去重）</p>
      <p>店铺承担优惠金额（店铺优惠券承担金额）：店铺优惠券承担金额</p>
      <p>运费金额（用户支付运费金额）：用户支付运费金额</p>
    </div>
    <div class="but">
      <div class="bb" @click="$emit('closecallback')">知道了</div>
    </div>
  </div>
</template>
<script>

export default {
  name: '',
  props: {},
  data() {
    return {
     
    }
  },
  methods: {
    
  },
  created() {
  },
  mounted(){},
  computed:{},
  components: {},
};
</script>
<style lang="less" scoped>
.sm_div{
  padding-left: 45px;
  padding-right: 45px;
  font-size: 24px;
  color: #999999;
  padding-bottom: 60px;
  .title{
    margin-top: 30px;
    font-size:32px;
    color: #000000;
    text-align: center;
  }
  p{
    margin-bottom: 20px;
  }
}
.but{
  margin: 0 auto;
  text-align: center;
  display: block;
  width: 299px;
  height: 75px;
  line-height: 75px;
  background: var(--epButtonColor);
  border-radius: 38px;
  .bb{
    font-size: 32px;
    color: var(--epTextColor);
  }
}
</style>